import React from 'react';
import { Box, Button, Card } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import NoResult from '../NoResult/NoResult';
import DossierDocumentsSignHeading from '../DossierDocumentsSignHeading/DossierDocumentsSignHeading';
import DossierDocumentSignItem from '../DossierDocumentSignItem/DossierDocumentSignItem';
import { useDocumentSign, useDocumentSignRender } from '../../../hooks';
import {
    useDocumentContext,
    useSelectedDossierContext,
    useDossierDocumentSignContext,
} from '../../../providers';

const DossierDocumentsSign: React.FunctionComponent = function () {
    const { dossier: formalityDossier } = useSelectedDossierContext();
    const { loading, dossiers } = useDossierDocumentSignContext();
    const { getDossierColor, getDossierAdditionalInfos, getDossierActions } =
        useDocumentSignRender();
    const { handleSignMultiDocuments } = useDocumentSign();
    const { getAllDocuments } = useDocumentContext();

    const availableDocuments = getAllDocuments().filter(
        (document) => document.fichierId !== undefined,
    );

    const handleAddItem = () => {
        handleSignMultiDocuments(
            formalityDossier.id as number,
            formalityDossier.prescripteurId as number,
            formalityDossier.prescripteurLibelle as string,
            formalityDossier.prescripteurEmail as string,
        );
    };

    const header = (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '16px',
                paddingBottom: '16px',
            }}
        >
            <DossierDocumentsSignHeading />
            {availableDocuments.length > 0 && (
                <Button
                    variant="text"
                    sx={{ display: 'flex', columnGap: '0.5em', color: 'text.gris35' }}
                    onClick={handleAddItem}
                >
                    <FaOptionIcon icon={['fasl', 'plus']} />
                    Ajouter un dossier
                </Button>
            )}
        </Box>
    );

    if (!loading && dossiers.length === 0) {
        return (
            <Card sx={{ paddingLeft: '0px' }}>
                {header}
                <NoResult title="Aucun dossier de signature électronique pour le moment" />
            </Card>
        );
    }

    return (
        <Card sx={{ paddingLeft: '0px' }}>
            {header}
            <Box
                sx={{
                    paddingLeft: '1em',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '1em',
                }}
            >
                {dossiers.map((dossier) => (
                    <DossierDocumentSignItem
                        title={dossier.subject}
                        icon="file-pdf"
                        key={dossier.id}
                        color={getDossierColor(dossier)}
                        additionalInfos={getDossierAdditionalInfos(dossier)}
                        actions={getDossierActions(dossier)}
                    />
                ))}
            </Box>
        </Card>
    );
};

export default DossierDocumentsSign;
